import { Component, Input } from '@angular/core'
import { FormControl } from '@angular/forms'
import { faPlus, faXmark } from '@fortawesome/free-solid-svg-icons'

@Component({
  selector: 'app-list-input',
  templateUrl: './list-input.component.html',
  styleUrls: ['./list-input.component.scss']
})
export class ListInputComponent {
  @Input({ required: true }) control: FormControl<string[]>;
  @Input() name: string;
  @Input() autocomplete: string;

  protected readonly addValueIcon = faPlus;
  protected readonly removeValueIcon = faXmark;
  protected currentValue = '';

  addValue(): void {
    const trimmedValue = this.currentValue.trim();
    if (trimmedValue) {
      this.control.markAsDirty();
      if (this.control.value.includes(trimmedValue)) {
        this.control.setErrors({ customError: 'error.valueAlreadyPresent' });
      } else {
        const updatedValue = this.control.value;
        updatedValue.push(trimmedValue);
        this.control.setValue(updatedValue);
        this.currentValue = '';
      }
    }
  }

  removeValue(index: number): void {
    this.control.markAsDirty();
    this.control.value.splice(index, 1);
  }

  onEnterPress(event: Event): void {
    event.preventDefault();
    this.addValue();
  }
}
